import axios from "axios";
import jwt_decode from "jwt-decode";

import { GET_PRODUCT } from "@/components/Product/service/api";
import { getScopes } from "@/components/service/api";
import pinia from "@/store";
import { usePermissionsStore, useProductsStore, useUserStore } from "@/store/modules";

const permissionsStore = usePermissionsStore(pinia);
const productsStore = useProductsStore(pinia);
const userStore = useUserStore(pinia);

export default {
  data: () => ({
    serverErrorMix: "",
    myMixVar: {
      // test: "test",
    },
  }),
  mounted() {
    for (const key in this.$data) {
      if (key.toLowerCase().includes("rule")) {
        if (Array.isArray(this.$data[key])) {
          this.$data[key].push(
            () => this.myMixVar.passwordRepeat === undefined || this.myMixVar.passwordRepeat
          );
        }
      }
    }
  },
  methods: {
    emitValueMix(value) {
      this.$emit("update:value", value);
      this.$emit("input", value);
    },
    setdataMix() {
      this.myMixVar.passwordRepeat = "test2";
      this.myMixVar.test2 = "test2";
      setTimeout(() => {
        this.$refs.myFormZVO.validate();
      }, 3000);
    },
    // Обработка ошибок при запросах
    handleErrorMix(error, isNotify) {
      const handlingStack = new Error().stack;
      // console.error('--- Обработка ошибки начата ---');
      const stackLines = typeof handlingStack === "string" ? handlingStack.split("\n") : [];
      console.error(
        "Разверни это, вторая ссылка то откуда выпала ошибка:\n",
        stackLines[2] ? stackLines[2].trim() : handlingStack
      );
      const fallbackDetail = error?.message || "Произошла ошибка";
      const responseData = error?.response?.data;
      const normalizedData = Array.isArray(responseData) ? responseData[0] : responseData;

      if (!normalizedData || typeof normalizedData !== "object") {
        if (isNotify) {
          this.$notify({
            group: "foo",
            text: fallbackDetail,
            type: "error",
          });
        }
        return {
          detail: fallbackDetail,
          code: error?.code || "unknown_error",
        };
      }

      if (!normalizedData.extra_data) {
        const detail = normalizedData.detail || fallbackDetail;
        if (isNotify) {
          this.$notify({
            group: "foo",
            text: detail,
            type: "error",
          });
        }

        return {
          ...normalizedData,
          detail,
        };
      }

      this.serverErrorMix = {};

      const extraData = normalizedData.extra_data;

      if (extraData && typeof extraData === "object") {
        for (let key in extraData) {
          if (Object.prototype.hasOwnProperty.call(extraData, key)) {
            this.serverErrorMix[key] = extraData[key];
          }
        }
      }

      return {
        ...normalizedData,
        detail: normalizedData.detail || fallbackDetail,
      };
    },

    async updateScopesMix() {
      // перезапрпашивает скопы пользователя(или пользователя в команде) и обновляет их в хранилище
      // Запрашиваем Разрешения
      const team = localStorage.getItem("selectedTeamSlug");
      const scopes = await getScopes(team !== "" ? team : null, this.$config);
      const allScopes = permissionsStore.allScopes;
      // Смешиваем с человекочитаемым названием
      this.mergePermissionsMix(scopes, allScopes);
    },

    mergePermissionsMix(obj1, obj2) {
      // Объединяем массивы billing
      obj1.billing.forEach((item1) => {
        const billing = obj2.billing.find((item2) => item2.code === item1.code);

        if (billing) {
          Object.assign(item1, billing);
        }
      });
      // Объединяем массивы team
      obj1.team.forEach((item1) => {
        const team = obj2.team.find((item2) => item2.code === item1.code);

        if (team) {
          Object.assign(item1, team);
        }
      });
      obj1.config = obj2.config;

      permissionsStore.SET_SCOPES_AND_PLANS(obj1);

      return obj1;
    },
    // Выбор моделей для 2 шага степпера (Используемые модели)
    getModelByTargetMix(product, type) {
      let modelTo = null;

      product.models.forEach((model) => {
        let arr = model.additional_data.split(" ");

        arr.forEach((item) => {
          if (type === "all") {
            const stringsToCheck = ["3d", "ar_android", "ar_ios"];
            const isAllStringsPresent = stringsToCheck.every((str) => arr.includes(str));
            if (isAllStringsPresent) {
              modelTo = model;
            }
          }
          if (item === type) {
            modelTo = model;
          }
        });
      });
      return modelTo;
    },

    async downloadZipMix(itemsToDownload, archiveName) {
      var JSZip = require("jszip");
      var JSZipUtils = require("jszip-utils");
      var FileSaver = require("file-saver");
      var zip = new JSZip();
      let errors = [];
      let counter = 0;

      // составление имени файла
      itemsToDownload.forEach(async function (item) {
        await JSZipUtils.getBinaryContent(item.url, async function (err, data) {
          if (err) {
            errors.push(err); // or handle the error
          }
          await zip.file(item.name, data, { binary: true });
          counter++;
          if (counter === itemsToDownload.length) {
            let content = await zip.generateAsync({ type: "blob" });
            FileSaver.saveAs(content, archiveName || "Zarbo-models");
          }
        });
      });
    },

    saveFileMix(file, name) {
      var FileSaver = require("file-saver");
      FileSaver.saveAs(file, name);
    },

    toCamelMix(s) {
      return s.replace(/([-_][a-z])/gi, ($1) => {
        return $1.toUpperCase().replace("-", "").replace("_", "");
      });
    },

    async getWidgetsByProductIdMix(prodId) {
      if (!prodId) {
        console.warn("prodId is " + prodId);
        return null;
      }
      const url = this.$config.BASE_URL + "/api/v1/widgets/?product=" + prodId;
      try {
        let resp = await this.$axios.get(url);
        return resp.data;
      } catch (error) {
        console.error("fail get widgets", error);
        return null;
      }
    },

    getFileExtentionMix(file) {
      return file.name.split(".").splice(-1, 1)[0];
    },

    async getProductByIdMix(productId) {
      if (!productId) {
        return null;
      }
      // const url = this.$config.BASE_URL + "/api/v1/products/" + productId + "/";

      try {
        const resp = await GET_PRODUCT(productId);

        productsStore.SET_VALUE({ key: "product", value: resp });
        return resp;
      } catch (error) {
        console.error("fail get product");
        throw error;
      }
    },

    getModelFromProductMix(product, format) {
      if (!Array.isArray(format)) {
        format = [format];
      }
      if (!product || product.models.length === 0 || !format) {
        return null;
      }
      const model = product.models.find((_model) => {
        return format.includes(_model.format); // совпадает формат и качество
      });
      return model;
    },

    getAndroidTooltipMix(product) {
      const color = this.getAndroidColorMix(product);
      return color === "green"
        ? "Установлена модель для просмотра на устройствах Android"
        : "Не установлена модель для просмотра на устройствах Android";
    },

    getIosTooltipMix(product) {
      const color = this.getIosColorMix(product);
      switch (color) {
        case "green":
          return "Установлена модель для просмотра на устройствах Apple";

        case "yellow":
          return 'Не установлена модель для просмотра на устройствах Apple. Модель конвертируется из модели для Android "на лету", однако, это может занять немного больше времени';

        case "red":
          return "Не установлена модель для просмотра на устройствах Apple";

        default:
          break;
      }
    },

    getWrbTooltipMix(product) {
      const color = this.getAndroidColorMix(product);
      return color === "green"
        ? "Установлена модель для просмотра в браузере"
        : "Не установлена модель для просмотра в браузере";
    },

    getAndroidColorMix(product) {
      const haveAndroid = product.models.find((item) => {
        return item.format === "glb" || item.format === "gltf";
      });
      return haveAndroid !== undefined ? "green" : "red";
    },

    getIosColorMix(product) {
      const haveIos = product.models.find((item) => {
        return item.format === "usdz";
      });
      if (haveIos === undefined) {
        const andr = this.getAndroidColorMix(product);
        return andr === "green" ? "yellow" : "red";
      } else {
        return "green";
      }
    },

    async refreshTokenMix() {
      if (!this.isTimeToUpdateAccessMix()) {
        // console.log("skip update token refreshTokenMix")
        return;
      }

      const refreshToken = localStorage.getItem("zarboRefreshToken");
      const url = this.$config.BASE_URL + "/api/token/refresh/";

      if (!refreshToken) {
        await this.$router.push("/login");
        return;
      }
      try {
        const resp = await axios.post(url, { refresh: refreshToken });
        localStorage.setItem("zarboAccessToken", resp.data.access);
        localStorage.setItem("zarboRefreshToken", resp.data.refresh);
        let decodedAccess = jwt_decode(resp.data.access);
        let decodedRefresh = jwt_decode(resp.data.refresh);
        localStorage.setItem("zarboExpireRefresh", decodedRefresh.exp);
        localStorage.setItem("zarboExpireAccess", decodedAccess.exp);

        userStore.SET_VALUE({ key: "isAuthorized", value: true });
        this.updateScopesMix();
        return this.getUserInfoMix(decodedAccess.user_id);
      } catch (error) {
        this.$router.push("/login");
        userStore.SET_VALUE({
          key: "isAuthorized",
          value: false,
        });
        console.info("fail update token", error);
        return null;
      }
    },

    async getUserInfoMix(userId) {
      const url = this.$config.BASE_URL + "/api/v1/auth/users/" + userId + "/";

      await axios.get(url).then((resp) => {
        userStore.SET_VALUE({
          key: "user",
          value: { ...resp.data, user_id: userId },
        });
        try {
          if (window.ym) {
            window.ym(this.$config.YANDEX_METRICA_ID, "userParams", { UserID: userId });
          }
        } catch (error) {
          console.info("metric disabled", error);
        }
      });
    },

    isTimeToUpdateAccessMix() {
      // вызывается в main.js даже если не подсвечивается
      const minTime = 60; // количество секунд меньше которого точно обновлять токен
      const minPercent = 0.1; // доля от времени жизни токена меньше которой нужно обновить токен(0.1 - меньше 10% от общего времени жизни)

      // Получаем access-токен из localStorage
      const access = localStorage.getItem("zarboAccessToken");
      if (!access) return false;

      try {
        // Декодируем JWT-токен (без проверки подписи)
        const decoded = jwt_decode(access);
        const now = Math.floor(Date.now() / 1000); // Текущее время в секундах
        const { iat, exp } = decoded; // iat — issued at, exp — expiration time

        // Проверка наличия обязательных полей
        if (!iat || !exp) return false;

        const lifetime = exp - iat; // Полное время жизни токена
        const remaining = exp - now; // Сколько времени осталось

        const remainingLessTime = remaining < minTime; // истекает по минимальному времени
        const remainingLessMinPercent = remaining / lifetime < minPercent; // истекает по процентам жизней

        // Если осталось меньше 10% времени жизни — нужно обновить токен
        return remainingLessTime || remainingLessMinPercent;
      } catch (e) {
        // Ошибка при декодировании токена
        console.error("Failed to decode token:", e);
        return false;
      }
    },
  },
};
